/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

import { gaWrapper } from 'helpers/analytics';
import makeRequest from 'utils/makeRequest';
import { dateToStringWithFormat } from 'utils/dateUtils';
// import { inViewForReact } from 'utils/common';
import InViewObserver from 'components/InViewObserver/InViewObserver';
import CardList from 'components_v2/common/CardList';
import Modal from 'components_v2/common/Modal';
import Link from 'components/Link';
import Card from 'components_v2/common/CardV2';
import s from './SliderWidgetWithModal.scss';
import PopupPortal from '../../../../../components_v2/mobile/PopupPortal/PopupPortal';

const SliderWidgetWithModal = props => {
  const {
    // newsmsid,
    isWapView,
    more = {},
    title = {},
    wu: url,
    gaData = { action: '', label: '' },
    usePopupPortal,
  } = props;
  const [asData, setAsData] = useState(null);
  const [isOpen, setOpen] = useState(false);
  const [currentPage, updateCurrentPage] = useState(1);
  const [isLoading, updateLoading] = useState(false);
  const [stopFetchData, setStopFetchData] = useState(false);
  const [modalData, setModalData] = useState([]);
  const settings = {
    slidesToShow: 3,
    slidesToScroll: 1,
    pauseOnHover: false,
    pauseOnFocus: false,
    dots: false,
    arrows: false, // explicitly disabled for liveblog timeline
    swipeToSlide: true,
    autoplay: false,
    draggable: false,
    initialSlide: 0,
    infinite: false,
  };
  const modalRef = useRef();

  const getData = curpg => {
    let finalUrl = '';
    if (url.includes('?')) {
      finalUrl = `${url}&curpg=${curpg}&stryno=5`;
    } else {
      finalUrl = `${url}?curpg=${curpg}&stryno=5`;
    }
    makeRequest
      .get(finalUrl, { isMobile: isWapView }, 'skipfeedengine')
      .catch(err => console.log(err))
      .then(data => {
        if (data && data.status === 200 && data.data && data.data.items) {
          const { items = [] } = data.data;
          items.map(x => {
            // eslint-disable-next-line no-param-reassign
            x.image = { id: x.imageid };
            return x;
          });
          if (curpg === 1) {
            setAsData(items);
            setModalData(items);
          } else {
            setModalData(modalData.concat(items));
          }
          if (items.length === 1) {
            setStopFetchData(true);
          }
          updateCurrentPage(curpg);
          updateLoading(false);
        } else {
          updateLoading(false);
          setStopFetchData(true);
        }
      });
  };
  const handleScroll = useCallback(
    () => {
      const elem = modalRef && modalRef.current;
      if (
        elem &&
        !isLoading &&
        !stopFetchData &&
        elem.scrollTop + elem.offsetHeight + 100 >= elem.scrollHeight
      ) {
        updateLoading(true);
        getData(currentPage + 1);
      }
    },
    [isLoading, stopFetchData, currentPage, modalData],
  );
  useEffect(
    () => {
      if (modalRef.current) {
        modalRef.current.addEventListener('scroll', handleScroll);
      }
      return () => {
        if (modalRef.current) {
          modalRef.current.removeEventListener('scroll', handleScroll);
        }
      };
    },
    [isOpen, handleScroll],
  );
  // useEffect(
  //   () => {
  //     getData(1);
  //   },
  //   [newsmsid],
  // );
  const closePopup = () => {
    try {
      const body = document.querySelector('body');
      body.classList.remove(s.modal_open);
    } catch (err) {
      throw err;
    }
    setOpen(false);
  };
  const openPopup = () => {
    try {
      const body = document.querySelector('body');
      body.classList.add(s.modal_open);
    } catch (err) {
      throw err;
    }
    gaWrapper(
      'send',
      'event',
      (typeof window !== 'undefined' && window.categoryForGA) || '',
      gaData.action,
      'full_coverage_cta',
    );
    setOpen(true);
  };
  const getCardList = () => (
    <CardList
      data={asData.slice(0, 3)}
      imgWidth="200"
      itemClass={`${s.innerborder}`}
      nonFeaturedListWrapperClass={isWapView ? '' : 'grid_wrapper'}
      nonFeaturedItemWrapperClass={isWapView ? s.listrow : 'col_l_4'}
      nonFeaturedListTileType={isWapView ? 'defaultTile' : 'isVerticalTile'}
      newga={`${gaData.action}#${gaData.label}_`}
      isInlineSmallIconCard={isWapView}
    />
  );
  const getCards = () =>
    asData.map((item, index) => (
      <Card
        data={item}
        itemClass={s.innerborder}
        isVerticalTile
        imgWidth="200"
        isInlineSmallIconCard={isWapView}
        key={item.id || `${item.tn}_${index}`}
        newga={`${gaData.action}#${gaData.label}_${item.wu || index}${
          gaData.category ? `#${gaData.category}` : ''
        }`}
      />
    ));

  return (
    <InViewObserver
      inViewCallback={() => {
        getData(1);
      }}
      viewMargin="500px 0px 500px 0px"
    >
      {(asData instanceof Array && !asData.length) ||
      !(asData instanceof Array) ? (
        ''
      ) : (
        <div className={s.AS_insert}>
          {title.link ? (
            <Link
              to={title.link}
              data-ga={title.ga}
              data-setgacategory
              className={s.Widgetheading}
            >
              {title.text}
            </Link>
          ) : (
            <div className={s.Widgetheading}>{title.text}</div>
          )}

          {isWapView ? (
            getCardList()
          ) : (
            <div className={s.AS_coverageCard}>
              <Slider {...settings}>{getCards()}</Slider>
            </div>
          )}
          {more.text && (
            <button onClick={openPopup} className={s.moreCoverage}>
              {more.text}
            </button>
          )}
          {isOpen && (
            <PopupPortal usePopupPortal={usePopupPortal}>
              <Modal onClose={closePopup} styles={s}>
                <div className={s.AS_InsertWrapper_Desktop}>
                  <h2 className={s.overlay_heading}>{title.text}</h2>
                  <div className={`${s.popup_innerList}`} ref={modalRef}>
                    <CardList
                      data={modalData}
                      imgWidth="200"
                      nonFeaturedListTileType="defaultTile"
                      itemClass={`${s.innerborder}`}
                      nonFeaturedItemWrapperClass={s.listrow}
                      timeStampFun={dateToStringWithFormat}
                      timeStampFormat="DD MMM, HH:mm [IST]"
                      newga={`${gaData.action}#${gaData.label}_`}
                      isInlineSmallIconCard={isWapView}
                    />
                  </div>
                </div>
              </Modal>
            </PopupPortal>
          )}
        </div>
      )}
    </InViewObserver>
  );
};

SliderWidgetWithModal.propTypes = {
  isWapView: PropTypes.bool,
  newsmsid: PropTypes.string.isRequired,
  more: PropTypes.shape({}),
  title: PropTypes.shape({}),
  usePopupPortal: PropTypes.bool,
};
SliderWidgetWithModal.defaultProps = {
  isWapView: true,
  more: {},
  title: {},
  usePopupPortal: false,
};

export default SliderWidgetWithModal;
